import { useEffect, useState } from "react";
import "./Offerbanner.css";

function OfferBanner() {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const hours = String(Math.floor(timeLeft / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((timeLeft % 3600) / 60)).padStart(2, "0");
  const seconds = String(timeLeft % 60).padStart(2, "0");

  return (
    <div id="student-offers" className="student-page-offerbanner" data-aos="zoom-in" data-aos-duration="800">
      <div className="student-page-offerbanner-content" data-aos="fade-up" data-aos-delay="80" data-aos-duration="700">
        <span className="student-page-offerbanner-tag">🔥 Limited Time Offer</span>
        <h1>50% OFF</h1>
        <p>
          Enroll today and get
          <br />
          <strong>FREE Certification Exam</strong>
        </p>

        <div className="student-page-offerbanner-timer" data-aos="zoom-in" data-aos-delay="120" data-aos-duration="650">
          <div className="student-page-offerbanner-time-box">
            <h2>{hours}</h2>
            <span>Hours</span>
          </div>

          <div className="student-page-offerbanner-time-box">
            <h2>{minutes}</h2>
            <span>Minutes</span>
          </div>

          <div className="student-page-offerbanner-time-box">
            <h2>{seconds}</h2>
            <span>Seconds</span>
          </div>
        </div>

        <button className="student-page-offerbanner-button">Enroll Now</button>
      </div>
    </div>
  );
}

export default OfferBanner;
